var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _polyline, _line, _line2, _polyline2, _polyline3, _circle, _path9, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThs21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.666,
    height: 636.249,
    viewBox: "0 0 282.666 636.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ths_21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M588.347,80.209S577.63,84.4,581.59,195.537l0.277,8.358s12.771,12.688,36.768,8.572V168.743",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.306,
    cy: 34.053,
    rx: 22.666,
    ry: 9.334,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M581.356,188.54s-11.415,1.172-13.512,17.947l6.756,400.5c0.163,9.66,22.262,15.723,28.532,17.409,53.3,14.328,106.36,30.172,158.651,47.877,13.142,4.449,27.05,9.055,41.122,7.743,18.57-1.733,27.453-14.722,39.629-26.9l6.057-462.009",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M618.635,212.467l6.757,395.452c0.134,7.844,3.9,14.565,11.532,16.955,13.788,4.318,27.635,8.461,41.463,12.652q41.487,12.573,83.068,24.833c12.144,3.581,24.256,7.328,36.949,8.335,7.963,0.633,16.818-.008,23.629-4.6,7.889-5.324,14.078-13.157,20.593-20.005",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M618.635,184.936s1.514-9.32,16.659-4.66l159.944,39.608s23.182,2.912,30.87-3.379l22.4-18.753",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M568.147,224.428s5.172,7.571,22.53,10.949,27.958,5.009,27.958,5.009",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M636.2,520.434h7.019a1.156,1.156,0,0,1,1.156,1.156h0v17.853a3.008,3.008,0,0,1-3.008,3.008H636.2a3.008,3.008,0,0,1-3.008-3.008v-16a3.008,3.008,0,0,1,3.007-3.009h0Z",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.851,
    y: 480.976,
    width: 1.442,
    height: 12.275,
    rx: 0.681,
    ry: 0.681,
    fill: "#62b6ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M641.934,154.065l165.652,41.006s11.161-4.053,27.03-22.383",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M698.652,168.105l25.891-21.648,107.972,25.315s19.571,7.456,16.076,19.338l-24.23,18.872s-8.854,5.591-34.249,0L618.635,168.743l14.678-16.309,8.621,1.631,0.26-14.344",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "157.45 101.713 157.45 92.75 160.201 89.954 162.443 45.6 157.45 36.863 149.629 36.863 138.679 48.396 130.99 69.288 130.99 112.001 127.728 114.214 112.351 111.418 113.749 67.501 123.767 38.261 138.562 20.438 150.561 17.525 158.366 30.922",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 158.366,
    y1: 30.922,
    x2: 158.366,
    y2: 38.466,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 131.559,
    y1: 123.361,
    x2: 130.99,
    y2: 112.001,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "112.351 111.418 90.101 100.186 84.789 98.089 86.769 56.152 97.487 27.961 112.281 10.021 125.678 8.157 130.99 10.254 150.561 17.525",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "61.007 90.45 62.078 48.58 72.795 20.389 87.59 2.449 99.683 0.766 106.298 2.85 125.678 8.157",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.418,
    cy: 167.723,
    r: 1.644,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M573.4,535.634s16.555,24.281,51.2,25.509",
    transform: "translate(-567.093 -44.744)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 228.145,
    y1: 175.14,
    x2: 225.116,
    y2: 625.456,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 84.789,
    y1: 98.089,
    x2: 61.007,
    y2: 90.45,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThs21);
export default __webpack_public_path__ + "static/media/ths_21.403938a773af3da69e83d3be540b91b8.svg";
export { ForwardRef as ReactComponent };